import { Box,Button } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BiPencil } from 'react-icons/bi';
import { trackEventMatomo } from '../../helpers/matomo';
import { ChamadoChecklist,chamadoConfigType,chamadoConfigTypeSubitem } from '../../types/new-form-filling/types';
import { ChecklistReportType } from '../../types/reports/types';
import { addTicketType } from './Modal/ModalDetailPrint';
import ModalEditTicketsAfter from './Modal/ModalEditTicketsAfter';

type props = {
  addingTickets: addTicketType | undefined,
  chamadosObj: ChamadoChecklist[] | undefined,
  chamadosConfig: chamadoConfigTypeSubitem | chamadoConfigType | undefined,
  formId: string,
  inicio: number,
  commingFromSub: boolean,
  chamadosConfigSub: chamadoConfigTypeSubitem | undefined,
  selected: ChecklistReportType,
};

export default function TicketListReportComponent({
  addingTickets,
  chamadosObj,
  chamadosConfig,
  formId,
  inicio,
  commingFromSub,
  chamadosConfigSub,
  selected,
}: props) {
  const initialChamados = chamadosObj ? [...chamadosObj] : [];
  const [chamadosState, setChamadosState] = useState<ChamadoChecklist[]>(chamadosObj || []);
  const [modalOpen, setModalOpen] = useState(false);
  const { t } = useTranslation('translation');
  const ClearAndExit = () => {
    setChamadosState(initialChamados);
    setModalOpen(false);
  };

  const closeModal = () => setModalOpen(false);

  return (
    <>
      <Box sx={{ mt: '10px', mb: '10px', displayPrint: 'none' }}>
        {(!commingFromSub
          && chamadosConfig ?
          (chamadosConfig.limiteChamado > 0
            && chamadosState
            && chamadosState.length >= chamadosConfig.limiteChamado)
            ? <Button
              variant='contained'
              className='button'
              disabled>
              {t('Reports.ticketList.maxCallsReachedForForm')}
            </Button>
            : <Button
              variant='contained'
              endIcon={<BiPencil />}
              className='button'
              onClick={() => {
                trackEventMatomo('Relatórios', 'click', 'button', 'abre modal');
                setModalOpen(true);
              }}>
              {t('Reports.ticketList.addCalls')}
            </Button>
          : chamadosConfigSub
            ? (chamadosConfigSub.limiteChamado > 0
              && chamadosState
              && chamadosState.length >= chamadosConfigSub.limiteChamado)
              ? <Button
                variant='contained'
                className='button'
                disabled>
                {t('Reports.ticketList.maxCallsReachedForSubitem')}
              </Button>
              : <Button
                variant='contained'
                endIcon={<BiPencil />}
                className='button'
                onClick={() => {
                  trackEventMatomo('Relatórios', 'click', 'button', 'abre modal');
                  setModalOpen(true);
                }}>
                {t('Reports.ticketList.addCalls')}
              </Button>
            : null)}
      </Box>
      {modalOpen
        && addingTickets
        && chamadosConfig
        && <ModalEditTicketsAfter
          chamadosObj={chamadosObj}
          open={modalOpen}
          setOpen={closeModal}
          ClearAndExit={ClearAndExit}
          chamados={chamadosState}
          setChamados={setChamadosState}
          currentElement={addingTickets}
          chamadosConfig={chamadosConfig}
          inicio={inicio}
          formId={formId}
          selected={selected}
        />
      }
    </>
  );
}
